import { render } from "./setEndGoldPriceDate.vue?vue&type=template&id=575fcc3c"
import script from "./setEndGoldPriceDate.vue?vue&type=script&lang=js"
export * from "./setEndGoldPriceDate.vue?vue&type=script&lang=js"

import "./setEndGoldPriceDate.vue?vue&type=style&index=0&id=575fcc3c&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__